module.exports = __webpack_public_path__ + "static/media/payment-gateway-2.c5716902.png";